import script from "./ServeManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServeManage.vue?vue&type=script&setup=true&lang=js"

import "./ServeManage.vue?vue&type=style&index=0&id=742cb91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742cb91e"]])

export default __exports__